import {useEffect} from "react";
import {usePage} from "@inertiajs/react";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";

export default function useFavouritesDataChange() {
    const {props} = usePage();
    const {favouritesData = []} = props;
    const {favouritesStore = {}} = useStoreMobx();

    useEffect(() => {
        favouritesStore.favouritesDataChange(favouritesData);
    }, [favouritesData]);
}
